import { api } from '../../../services/api/axios';
import { authService } from '../../auth/services/authService';

export interface Card {
  id: string;
  token: string;
  card_type: string;
  masked_number: string;
  is_default: boolean;
}

export interface CardsResponse {
  success: boolean;
  cards: Card[];
}

export interface AddCardPayload {
  rememberCard: boolean;
  card: {
    number: string;
    expirationMonth: string;
    expirationYear: string;
    securityCode: string;
    name: string;
  };
}

export const paymentService = {
  getCards: async (): Promise<CardsResponse> => {
    const token = authService.getToken();
    try {
      const response = await api.get('/card', {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  deleteCard: async (card_id: string): Promise<void> => {
    const token = authService.getToken();
    try {
      await api.delete('/card', {
        headers: { Authorization: `Bearer ${token}` },
        data: { card_id },
      });
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },

  addCard: async (payload: AddCardPayload): Promise<void> => {
    const token = authService.getToken();
    try {
      await api.post('/card/add', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err: any) {
      const apiMessage = err.response?.data?.message || err.response?.data?.error;
      throw new Error(apiMessage || err.message);
    }
  },
};
